import React, { useEffect } from 'react';
import { useHealthQuestionnairePageStore } from 'store/pages/subscriber/imq/health-questionnaire/pageStore';
import { observer } from 'mobx-react-lite';
import EmployeeFlowLayout from 'components/common/subscriber/EmployeeFlowLayout';
import { SubscriberRouteV2Id } from 'routes/routesConfigV2';
import { MedicalCategoryCard } from 'components/common/subscriber/imq/health-questionnaire/MedicalCategoryCard';
import { HealthQuestionnaireLayout } from 'components/common/subscriber/imq/health-questionnaire/HealthQuestionnaireLayout';
import { ManageConditionsModal } from 'components/common/subscriber/imq/health-questionnaire/ManageConditionsModal';

const PageContent: React.FC = observer(() => {
  const {
    getInitialData,
    isInitialLoading,
    flowDelegate,
    subscriberImqModule,
    editCategory,
    onManageCondition,
    manageConditionModalDelegate,
    completeChecklistStep,
    canComplete,
    isStepCompleted,
  } = useHealthQuestionnairePageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <>
      <EmployeeFlowLayout
        contentWidth="standard"
        flowDelegate={flowDelegate}
        pageId={SubscriberRouteV2Id.SUBSCRIBER_HEALTH_QUESTIONNAIRE}
        isInitialLoading={isInitialLoading}
        pageHeader={{
          subtitle: subscriberImqModule.categoriesProgressText,
        }}
        pageFooter={{
          onComplete: completeChecklistStep,
          completeButtonText: isStepCompleted ? 'Update' : 'Complete',
          disableCompleteButton: !canComplete,
        }}
      >
        <HealthQuestionnaireLayout>
          {subscriberImqModule.medicalCategories.map((category) => {
            const categoryName = category.name;

            return (
              <MedicalCategoryCard
                key={categoryName}
                name={categoryName}
                status={category.status}
                conditions={category.reportedConditions ?? []}
                editCategory={(): void => editCategory(categoryName)}
                manageCondition={(condition, affectedPeople): void =>
                  onManageCondition(categoryName, condition, affectedPeople)
                }
              />
            );
          })}
        </HealthQuestionnaireLayout>
      </EmployeeFlowLayout>
      <ManageConditionsModal manageConditionModalDelegate={manageConditionModalDelegate} />
    </>
  );
});

export default PageContent;
